import { EarthBrainUtils } from "../utilities/earthbrainutility";
// Singleton class to create floating cesium entities in cesium viewer
export class CesiumService {
    _viewer;
    static _instance;
    constructor(viewer) {
        this._viewer = viewer;
    }
    static getInstance(viewer) {
        if (!CesiumService._instance && viewer) {
            CesiumService._instance = new CesiumService(viewer);
        }
        if (!CesiumService._instance) {
            throw new Error("Viewer is not initialized");
        }
        return CesiumService._instance;
    }
    addSphere(position, color, id, pickInfo) {
        if (id && this._viewer.entities.getById(id)) {
            return null; //Entity with same id already exists, do not create a new one
        }
        const sphere = EarthBrainUtils.addSphere(this._viewer, position, color, undefined, undefined, id);
        if (pickInfo) {
            sphere.addProperty("pickInfo"); //Information when this sphere gets picked
            sphere["pickInfo"] = pickInfo;
        }
        return sphere;
    }
    addLabel(position, text, params) {
        const label = EarthBrainUtils.addLabel(this._viewer, position, text, params);
        return label;
    }
}
//# sourceMappingURL=cesium-services.js.map